import { render, staticRenderFns } from "./ColorNumber.vue?vue&type=template&id=f09b9ce6&"
import script from "./ColorNumber.vue?vue&type=script&lang=js&"
export * from "./ColorNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports